module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-3c7409b8c5420ebd6022acae44779108.woff";